
// External libraries
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai"

// Components
import { Body, BodyColor, BodyType, Button, ButtonTheme, ButtonVariant, Heading, InfoPanel, TypographyColor, TypographyType } from "../../ui-elements"
import { POICategoryListItem } from "./POICategoryListItem";
import { useRecoilState, useRecoilValue } from "recoil";
import { geoState, POICategories, selPOICategories } from "../../states";
import * as Constants from '../../utils/constants/Constants';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface POICategoryListProps {
    page: string;
    isOpen: boolean;
    handleListOpen: (keyName: string, tagName?: string) => void;
}

export const POICategoryList = ({ page, isOpen, handleListOpen }: POICategoryListProps) => {
    const selectedGeo = useRecoilValue(geoState);
    const poiCategories = useRecoilValue(POICategories);
    const [selCB, setSelCB] = useState<number | null>(null);
    const [selCategoryList, setSelCategoryList] = useRecoilState(selPOICategories);
    const [selTempCats, setSelTempCats] = useState(selCategoryList);

    // const handleCategoryChange = (event: any, categoryKey: number) => {
    //     if ((event.target as HTMLElement).tagName === 'INPUT' && selCB === categoryKey) return;
    //     setSelCB(selCB === categoryKey ? null : categoryKey);
    // }

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setSelTempCats(checked ?
            poiCategories.reduce((acc: { category: number[]; subcategory: number[]; }, category) => {
                acc.category.push(category.key);

                if (category.sub_categories && category.sub_categories.length > 0) {
                    acc.subcategory.push(...category.sub_categories.map(sub => sub.key));
                }

                return acc;
            }, { category: [], subcategory: [] }) :
            { category: [], subcategory: [] });
    }

    const handleCategoryChange = (categoryKey: number) => {
        setSelCB(selCB === categoryKey ? null : categoryKey);
    }

    const handleCancelFilter = () => {
        setSelTempCats(selCategoryList);
        handleListOpen('categories');
    }

    const handleApplyFilter = () => {
        setSelCategoryList(selTempCats);
        localStorage.setItem('selCategoryList', JSON.stringify(selTempCats));
        handleListOpen('categories');
    }

    const updateTempCatList = (listName: string, list: number[]) => {
        setSelTempCats(prev => ({ ...prev, [listName]: list }));
    }

    useEffect(() => {
        if (selCategoryList) {
            setSelTempCats(selCategoryList);
        }
    }, [selCategoryList]);

    // useEffect(() => {
    //     if (poiCategories && poiCategories.length > 0) {
    //         const selCats = {
    //             category: poiCategories.map(category => category.key),
    //             subcategory: poiCategories.flatMap(category => category.sub_categories?.map(subCat => subCat.key) || []),
    //         };
    //         setSelCategoryList(selCats);
    //     }
    // }, [poiCategories]);

    useEffect(() => {
        if (!isOpen) {
            setSelTempCats(selCategoryList);
            setSelCB(null);
        }
    }, [isOpen]);

    return (
        // <div className="m-0 p-0 position-relative">
        <div className={`m-0 p-0 ${page === "Home" ? "" : "position-relative h-100"}`}>
            {/* <div className=""> */}
            <div
                className={`d-flex justify-content-between align-items-center cursor-pointer padding-top-bottom-2 padding-left-right-5 poi-category h-100 ${page === "Dashboard" && "width-17-688vw"}`}
                onClick={(event) => handleListOpen('categories', (event.target as HTMLElement).tagName)}
            >
                <div className="d-flex justify-content-start align-items-center gap-2">
                    {!!selectedGeo.sub_district && <span className="presence-indicator category-indicator"></span>}
                    <Heading
                        title={`Categories (${selCategoryList?.category?.length?.toString().padStart(2, "0")})`}
                        type={TypographyType.h5}
                        colour={TypographyColor.secondary}
                        classname="icon-gray-0"
                    />
                    {page === "Home" && <InfoPanel text={Constants.iButtonText.homePage.leftPanel.categories} classname='icon-gray-0 fs-16 margin-left-2' />}
                </div>
                {page === "Home" ?
                    <span className="material-symbols-outlined fs-18 icon-gray-0">keyboard_arrow_right</span> :
                    (isOpen ? <IoIosArrowUp className="fs-17 icon-gray-0" /> : <IoIosArrowDown className="fs-17 icon-gray-0" />)
                }
            </div>
            {/* </div> */}
            {isOpen &&
                <div className={`${page === "Home" ? "poi-category-list-home" : "poi-category-list-dashboard"}`}>
                    {page === 'Home' &&
                        <div className="d-flex justify-content-between align-items-center border-bottom padding-top-bottom-4 padding-left-right-5">
                            <Body
                                type={BodyType.p3}
                                color={BodyColor.secondary}
                                classname="p-0"
                            >
                                Select Categories
                            </Body>
                            <AiOutlineClose className="fs-12 text-black cursor-pointer" onClick={handleCancelFilter} />
                        </div>}
                    <div className="padding-top-bottom-2 no-scrollbar poi-cats-list">
                        <div className="d-flex justify-content-start align-items-center cursor-pointer padding-left-right-5 padding-top-bottom-3 poi-category">
                            <div className="width-10 d-flex justify-content-start align-items-center">
                                <input
                                    className="p-0"
                                    type="checkbox"
                                    checked={poiCategories.length === selTempCats.category.length}
                                    onChange={(event) => handleSelectAll(event)}
                                />
                            </div>
                            <Heading
                                title='Select All'
                                colour={TypographyColor.secondary}
                                type={TypographyType.h6}
                                classname='m-0 p-0 text-start width-90 d-flex justify-content-between align-items-center'
                            />
                        </div>
                        {poiCategories.map((category) => (
                            <div
                                key={category.key}
                                className={`cursor-pointer padding-left-right-5 padding-top-bottom-1 poi-category ${selCB === category.key ? 'poi-category-selected' : ''}`}
                            // onClick={(event) => handleCategoryChange(event, category.key)}
                            >
                                <POICategoryListItem
                                    type='category'
                                    category={category}
                                    selCB={selCB}
                                    selTempCats={selTempCats}
                                    updateTempCatList={updateTempCatList}
                                    handleCategoryChange={handleCategoryChange}
                                />

                                {selCB === category.key && category.sub_categories?.map(sub_category => (
                                    <div key={sub_category.key} className="padding-left-4">
                                        <POICategoryListItem
                                            type='subcategory'
                                            category={sub_category}
                                            selCB={selCB}
                                            selTempCats={selTempCats}
                                            updateTempCatList={updateTempCatList}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-around align-items-center padding-top-bottom-3 border-top">
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.transparent}
                            type='button'
                            classname='padding-left-right-3'
                            onClick={handleCancelFilter}
                        >
                            Cancel
                        </Button>
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.bordered}
                            type='button'
                            classname='padding-left-right-5'
                            onClick={handleApplyFilter}
                            disabled={selTempCats.category.length === 0 && selTempCats.subcategory.length === 0}
                        >
                            Apply
                        </Button>
                    </div>

                    {/* div input box - text - divicon div */}
                </div>
            }
        </div>
    )
}